// Generated by scripts/sync-stripe-paywall-prices.mjs — do not edit by hand.
export default {
  "generatedAt": "2026-07-07T09:26:03.731Z",
  "source": "stripe",
  "stripeMode": "tier_catalog",
  "amounts": {
    "1": {
      "lightMonthly": 5,
      "lightYearly": 36,
      "lernMonthly": 10,
      "lernYearly": 60,
      "eduMonthly": 25,
      "eduYearly": 180
    },
    "2": {
      "lightMonthly": 5,
      "lightYearly": 24,
      "lernMonthly": 8,
      "lernYearly": 36,
      "eduMonthly": 15,
      "eduYearly": 96
    }
  },
  "prices": {
    "STRIPE_PRICE_T1_LIGHT_MONTHLY": {
      "priceId": "price_1TkkWOLvfiTwQ1HhYtBI0JJ7",
      "unitAmountCents": 500,
      "currency": "eur"
    },
    "STRIPE_PRICE_T1_LIGHT_YEARLY": {
      "priceId": "price_1TkkX8LvfiTwQ1HhnwB4K2I9",
      "unitAmountCents": 3600,
      "currency": "eur"
    },
    "STRIPE_PRICE_T1_SOLO_MONTHLY": {
      "priceId": "price_1TZEhZLvfiTwQ1HhCUxTlwJT",
      "unitAmountCents": 1000,
      "currency": "eur"
    },
    "STRIPE_PRICE_T1_SOLO_YEARLY": {
      "priceId": "price_1TZEqyLvfiTwQ1HhY07DS8Nm",
      "unitAmountCents": 6000,
      "currency": "eur"
    },
    "STRIPE_PRICE_T1_EDU_MONTHLY": {
      "priceId": "price_1TkkdgLvfiTwQ1HhuSaifmJy",
      "unitAmountCents": 2500,
      "currency": "eur"
    },
    "STRIPE_PRICE_T1_EDU_YEARLY": {
      "priceId": "price_1TkkeWLvfiTwQ1HhrWrmJaUv",
      "unitAmountCents": 18000,
      "currency": "eur"
    },
    "STRIPE_PRICE_T2_LIGHT_MONTHLY": {
      "priceId": "price_1TkkWOLvfiTwQ1HhYtBI0JJ7",
      "unitAmountCents": 500,
      "currency": "eur"
    },
    "STRIPE_PRICE_T2_LIGHT_YEARLY": {
      "priceId": "price_1TkkX8LvfiTwQ1HhA164lnDF",
      "unitAmountCents": 2400,
      "currency": "eur"
    },
    "STRIPE_PRICE_T2_SOLO_MONTHLY": {
      "priceId": "price_1TgLopLvfiTwQ1HhH3n7CCkK",
      "unitAmountCents": 800,
      "currency": "eur"
    },
    "STRIPE_PRICE_T2_SOLO_YEARLY": {
      "priceId": "price_1TgLpALvfiTwQ1HhsotG1w4o",
      "unitAmountCents": 3600,
      "currency": "eur"
    },
    "STRIPE_PRICE_T2_EDU_MONTHLY": {
      "priceId": "price_1TZEjeLvfiTwQ1HhaerBYAER",
      "unitAmountCents": 1500,
      "currency": "eur"
    },
    "STRIPE_PRICE_T2_EDU_YEARLY": {
      "priceId": "price_1TgLrzLvfiTwQ1Hh7fOPsRZM",
      "unitAmountCents": 9600,
      "currency": "eur"
    }
  }
};
